<section class="modern-services-section modern-section dingo-section dingo-bg-accent">
  <div class="container">
    <div class="services-section-head home-section-head section-head reveal-on-scroll" data-reveal="section-head">
      <p class="home-section-kicker">Ecosistema digital</p>
      <h2 class="home-section-title">
        Tecnología y growth conectados para <span class="highlight-green">escalar negocios</span>
      </h2>
      <p class="home-section-desc">
        Integramos marketing, desarrollo, automatización y data para construir sistemas digitales orientados a
        resultados reales.
      </p>
    </div>

    <div class="services-system">
      <div class="services-column services-column--left">
        <article class="service-node reveal-on-scroll" data-reveal="card" style="--reveal-order: 1">
          <div class="service-node-icon"><i class="bi bi-laptop"></i></div>
          <div>
            <h3>Desarrollo Web</h3>
            <p>Sitios y plataformas digitales a medida, optimizadas para conversión y rendimiento.</p>
          </div>
        </article>

        <article class="service-node reveal-on-scroll" data-reveal="card" style="--reveal-order: 2">
          <div class="service-node-icon"><i class="bi bi-phone"></i></div>
          <div>
            <h3>Desarrollo de Apps</h3>
            <p>Experiencias móviles y empresariales diseñadas para impactar, fidelizar y escalar.</p>
          </div>
        </article>

        <article class="service-node reveal-on-scroll" data-reveal="card" style="--reveal-order: 3">
          <div class="service-node-icon"><i class="bi bi-link"></i></div>
          <div>
            <h3>Blockchain</h3>
            <p>Soluciones blockchain seguras y escalables para nuevos modelos digitales.</p>
          </div>
        </article>
      </div>

      <div class="services-device reveal-on-scroll" data-reveal="media" style="--reveal-order: 2">
        <div class="services-device-shell">
          <img class="img-fluid" src="assets/images/home/phone.png" alt="Grupo Dingo" />
        </div>
      </div>

      <div class="services-column services-column--right">
        <article class="service-node reveal-on-scroll" data-reveal="card" style="--reveal-order: 1">
          <div class="service-node-icon"><i class="fa fa-bar-chart"></i></div>
          <div>
            <h3>Marketing Digital</h3>
            <p>Estrategias para captar clientes, aumentar visibilidad y generar resultados medibles.</p>
          </div>
        </article>

        <article class="service-node reveal-on-scroll" data-reveal="card" style="--reveal-order: 2">
          <div class="service-node-icon"><i class="bi bi-graph-up-arrow"></i></div>
          <div>
            <h3>Business Intelligence</h3>
            <p>Dashboards, análisis y datos accionables para tomar mejores decisiones.</p>
          </div>
        </article>

        <article class="service-node reveal-on-scroll" data-reveal="card" style="--reveal-order: 3">
          <div class="service-node-icon"><i class="bi bi-megaphone"></i></div>
          <div>
            <h3>Publicidad</h3>
            <p>Campañas personalizadas para conectar con audiencias reales y potenciar crecimiento.</p>
          </div>
        </article>
      </div>
    </div>
  </div>
</section>
